import React, { useEffect, useState, useRef } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import "../css/Requisitions.css";
import Sidebar from './Sidebar';
import { jwtDecode } from 'jwt-decode';
import PrintButton from './PrintButton';
import ExportPDFButton from './ExportPDFButton';
import ExportExcelButton from './ExportExcelButton';
import ExportTableToExcelButton from './ExportTableToExcelButton';

const StaffSurrendersSummary = () => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const [requisitions, setRequisitions] = useState([]);
  const [surrenderRequisitions, setSurrenderRequisitions] = useState([]);
  const theUserType = localStorage.getItem('userType');
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(location.state?.defaultTab || 'Disbursed'); 
  const storedFullName = localStorage.getItem('fullName');
  const [reviewers, setReviewers] = useState([]);
  const theUserId = localStorage.getItem('userId');
  const [reviewerNumber, setReviewerNumber] = useState(null);
  const [formArray, setFormArray] = useState([]);
  const contentRef = useRef();
  const [surrenderDetails, setSurrenderDetails] = useState([]);
  const [expectedSurrenderAmount, setExpectedSurrenderAmount] = useState(0);
  const [loadingSurrenderDetails, setLoadingSurrenderDetails] = useState(false);
  const [loadingDisbursed, setLoadingDisbursed] = useState(false);

  
          const [formData, setFormData] = useState(() => {
                    
            return {
                country: '',
                staffName: '',
                staffLevel: '',
                projectCode: '',
                activityPurpose: '',
                projectName: '',
                from: '',
                to: '',
                activityName: '',
                hubOffice: '',
                supervisorName: '',
                budgetLineCode: '',
                targetClient: '',
                expectedImpact: '',
                userType: '',
                userId: '',
                payMode: '',
                bankName:'',
                branch:'',
                accountNumber: '',
                phoneNumber: '',
                requisitionDate: '', 
                requisitionID: '',
                status: 'Draft',  
                costDrivers: [{ costDriver: '', customCostDriver: '' }], 
                districtAndAreaProgramPairs: [
                  { district: "", areaProgram: "" }
                ], 
              };
            });
  
  

  useEffect(() => {
    const fetchReviewers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/reviewers`);
        const data = response.data;
  
        if (!Array.isArray(data.$values)) {
          console.error("Unexpected response format:", data);
          setReviewers([]);
          return;
        }
  
        const allReviewers = data.$values.map(r => ({
          ...r,
          id: String(r.id)
        }));
        setReviewers(allReviewers);
  
        if (!theUserId) return;
  
        const current = allReviewers.find(r => r.id === String(theUserId));
        if (!current) return;
  
        const currentNum = current.reviewerNumber;
        setReviewerNumber(currentNum);
  
      } catch (error) {
        console.error("Error fetching reviewers:", error);
        setReviewers([]);
      }
    };
  
    fetchReviewers();
  }, [theUserId]);
  

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
  
    const decoded = jwtDecode(token); 
    setReviewerNumber(decoded.reviewerNumber || null); 
    console.log("Reviewer number", reviewerNumber);
  }, []);
  
  useEffect(() => {
    if (activeTab === 'Disbursed') {
      fetchDisbursedRequisitions();
    } else if (activeTab === 'Surrender Submitted') {
      fetchSurrenderSubmittedRequisitions();

    }
  }, [activeTab]);


useEffect(() => {
  if (activeTab === 'Surrender Submitted' && surrenderRequisitions.length > 0) {
    fetchSurrenderDetailsAndCalculate();
  }
}, [surrenderRequisitions, activeTab]);

const fetchSurrenderDetailsIndividually = async () => {
  try {
    const token = localStorage.getItem("token");
    
    console.log("Fallback: Fetching surrender details individually...");

    const surrenderDetailsWithVariances = await Promise.all(
      surrenderRequisitions.map(async (requisition) => {
        try {
          console.log(`Fetching surrender details for: ${requisition.requisitionID}`);
          
          const detailResponse = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Surrender/${requisition.requisitionID}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          
          const surrenderDetail = detailResponse.data;
          
          // Calculate total variance for this surrender
          const advanceActuals = surrenderDetail.advanceActualsAndVariances || [];
          const surrenderVariance = advanceActuals.reduce((sum, variance) => {
            return sum + (variance.variance || 0);
          }, 0);
          
          return {
            ...surrenderDetail,
            totalVariance: surrenderVariance
          };
        } catch (error) {
          console.error(`Error fetching surrender details for ${requisition.requisitionID}:`, error);
          return { 
            requisitionID: requisition.requisitionID,
            totalVariance: 0,
            advanceActualsAndVariances: []
          };
        }
      })
    );

    setSurrenderDetails(surrenderDetailsWithVariances);

    const totalExpectedSurrender = surrenderDetailsWithVariances.reduce((total, surrender) => {
      return total + surrender.totalVariance;
    }, 0);
    
    setExpectedSurrenderAmount(totalExpectedSurrender);

  } catch (err) {
    console.error("Error in fallback surrender details fetch:", err);
    setSurrenderDetails([]);
    setExpectedSurrenderAmount(0);
  }
};

// Your existing function (updated with proper error handling)
const fetchSurrenderDetailsAndCalculate = async () => {
  try {
    setLoadingSurrenderDetails(true);
    const token = localStorage.getItem("token");
    
    const requisitionIDs = surrenderRequisitions.map(req => req.requisitionID);
    
    // Try the batch endpoint first
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/Surrender/batch`,
      { requisitionIDs },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    
    const surrenderDetailsWithVariances = response.data;
    
    setSurrenderDetails(surrenderDetailsWithVariances);
    
    const totalExpectedSurrender = surrenderDetailsWithVariances.reduce((total, surrender) => {
      return total + surrender.totalVariance;
    }, 0);
    
    setExpectedSurrenderAmount(totalExpectedSurrender);
    
  } catch (err) {
    console.error("Error with batch endpoint, falling back to individual calls:", err);
    // Fallback to individual calls
    await fetchSurrenderDetailsIndividually();
  } finally {
    setLoadingSurrenderDetails(false);
  }
};

  const calculateTotalDisbursedAmount = () => {
    return requisitions.reduce((total, requisition) => {
      return total + calculateTotalAmount(requisition.costDrivers);
    }, 0);
  };
  
const getExportData = () => {
  if (activeTab === 'Disbursed') {
    return requisitions.map(requisition => ({
      'Staff Name': requisition.staffName,
      'Activity Name': requisition.activityName,
      'Activity Duration': formatDateRange(requisition.from, requisition.to),
      'Amount Disbursed': calculateTotalAmount(requisition.costDrivers), // Raw number for calculations
      'Disbursed Date': formatDate(requisition.disbursedDate),
      'Status': requisition.status,
      'Requisition ID': requisition.requisitionID
    }));
  } else if (activeTab === 'Surrender Submitted') {
    return surrenderRequisitions.map(requisition => {
      const surrenderDetail = surrenderDetails.find(
        detail => detail.requisitionID === requisition.requisitionID
      );
      const totalVariance = surrenderDetail?.totalVariance || 0;
      const amountDisbursed = calculateTotalAmount(requisition.costDrivers);
      
      return {
        'Staff Name': requisition.staffName,
        'Activity Name': requisition.activityName,
        'Activity Duration': formatDateRange(requisition.from, requisition.to),
        'Amount Disbursed': amountDisbursed, // Raw number for calculations
        'Disbursed Date': formatDate(requisition.disbursedDate),
        'Variance': totalVariance, // Raw number for calculations
        'Status': requisition.status,
        'Date Surrendered': surrenderDetail?.surrenderDateString ? formatDate(surrenderDetail.surrenderDateString) : 'N/A',
        'Requisition ID': requisition.requisitionID
      };
    });
  }
  return [];
};
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleView = (requisitionID) => {
    navigate(`/view-requisition/${requisitionID}`);
  };

  const handleSurrender = (requisitionID) => {
    navigate(`/surrender/${requisitionID}`);
  };

  const handleReviewSurrender = (requisitionID) => {
    navigate(`/review-surrender/${requisitionID}`);
  };

  // Fetch requisitions with status "Disbursed"
  const fetchDisbursedRequisitions = async () => {
    try {
      setLoadingDisbursed(true);
      console.log("Fetching disbursed requisitions...");
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId"); 
  
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition/status`, {
        params: {
          status: 'Disbursed',
          excludeUserId: userId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      const data = Array.isArray(response.data)
        ? response.data
        : response.data.$values ?? [];
  
      console.log("Basic requisitions fetched:", data);
  
      // Fetch detailed data for each requisition to get cost drivers
      const detailedRequisitions = await Promise.all(
        data.map(async (requisition) => {
          try {
            const detailResponse = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/Requisition/${requisition.requisitionID}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            console.log(`Full API response for ${requisition.requisitionID}:`, detailResponse.data); 
            return detailResponse.data;
          } catch (error) {
            console.error(`Error fetching details for ${requisition.requisitionID}:`, error);
            return requisition; // Return original if detail fetch fails
          }
        })
      );
  
      console.log("Detailed requisitions with cost drivers:", detailedRequisitions);
      setRequisitions(detailedRequisitions);
      setError(null);
    } catch (err) {
      console.error("Error fetching disbursed:", err); // ADD THIS
      console.error(err);
      if (err.response?.status === 404) {
        setError(`No disbursed requisitions found.`);
      } else if (err.response?.status === 401) {
        setError("You must be logged in to view requisitions.");
      } else {
        setError("Error");
        console.error("Error fetching disbursed requisitions.",err);
      }
      setRequisitions([]);
    } finally {
      setLoadingDisbursed(false); // ADD THIS
    }
  };

  // Fetch requisitions with status "Surrender Submitted"
  const fetchSurrenderSubmittedRequisitions = async () => {
    try {
      console.log("Fetching requisitions whose surrender was submitted...");
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId"); 

      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition/status`, {
        params: {
          status: 'Surrender Submitted',
          excludeUserId: userId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("API Response for surrender:", response); // ADD THIS

      
      const data = Array.isArray(response.data)
        ? response.data
        : response.data.$values ?? [];

        console.log("Processed surrender data:", data); // ADD THIS
    console.log("Number of surrender requisitions:", data.length); // ADD THIS

    const detailedSurrenderRequisitions = await Promise.all(
      data.map(async (requisition) => {
        try {
          const detailResponse = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Requisition/${requisition.requisitionID}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          
          console.log(`Detailed surrender data for ${requisition.requisitionID}:`, {
            hasCostDrivers: detailResponse.data.costDrivers?.length > 0,
            totalTotal: detailResponse.data.costDrivers?.[0]?.totalTotal
          });
          
          return detailResponse.data;
        } catch (error) {
          console.error(`Error fetching surrender details for ${requisition.requisitionID}:`, error);
          return requisition; // Return original if detail fetch fails
        }
      })
    );

    console.log("All detailed surrender requisitions:", detailedSurrenderRequisitions);
    setSurrenderRequisitions(detailedSurrenderRequisitions);
    setError(null);
  } catch (err) {
    console.error("Error fetching surrender:", err);
    if (err.response?.status === 404) {
      setError(`No surrenders.`);
    } else if (err.response?.status === 401) {
      setError("You must be logged in to view requisitions.");
    } else {
      setError("Error fetching surrender submitted requisitions.");
    }
    setSurrenderRequisitions([]);
  } finally {
    setLoadingSurrenderDetails(false); // ADD THIS
  }
};

    


  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return `${date.getDate()} ${date.toLocaleString("en-US", { month: "long" })} ${date.getFullYear()}`;
  };

  // Format date range
  const formatDateRange = (fromDate, toDate) => {
    if (!fromDate || !toDate) return 'N/A';
    const from = new Date(fromDate);
    const to = new Date(toDate);
    return `${from.getDate()} ${from.toLocaleString("en-US", { month: "short" })} - ${to.getDate()} ${to.toLocaleString("en-US", { month: "short" })} ${to.getFullYear()}`;
  };

  const calculateTotalAmount = (costDrivers) => {
    return costDrivers?.[0]?.totalTotal || 0;
  };

  const getStatusClass = (status) => {
    if (status === "Disbursed") return "status-disbursed";
    if (status === "Surrender Submitted") return "status-surrender-submitted";
    if (status === "Surrender Approved") return "status-surrender-approved";
    if (status.startsWith("Reviewed by")) return "status-reviewed";
    return "";
  };


  const DebugVarianceData = () => {
    if (activeTab === 'Surrender Submitted') {
      return (
        <div className="mt-3 p-3 bg-light border rounded">
          <h6>Debug Variance Data:</h6>
          <pre>
            {JSON.stringify(surrenderDetails.map(d => ({
              requisitionID: d.requisitionID,
              totalVariance: d.totalVariance,
              advanceActualsCount: d.advanceActualsAndVariances?.length,
              advanceActuals: d.advanceActualsAndVariances
            })), null, 2)}
          </pre>
        </div>
      );
    }
    return null;
  };

  // Temporary debug - add this before your return statement
console.log("=== DEBUG: DATA MISMATCH ANALYSIS ===");
console.log("Surrender Requisitions count:", surrenderRequisitions.length);
console.log("Surrender Requisitions IDs:", surrenderRequisitions.map(r => r.requisitionID));
console.log("Surrender Details count:", surrenderDetails.length);
console.log("Surrender Details IDs:", surrenderDetails.map(d => d.requisitionID));

// Check for missing matches
const missingMatches = surrenderRequisitions.filter(req => 
  !surrenderDetails.some(detail => detail.requisitionID === req.requisitionID)
);
console.log("Requisitions missing surrender details:", missingMatches.map(r => r.requisitionID));

// Check for duplicate matches
const duplicateMatches = surrenderRequisitions.filter(req => {
  const matches = surrenderDetails.filter(detail => detail.requisitionID === req.requisitionID);
  return matches.length > 1;
});
console.log("Requisitions with duplicate surrender details:", duplicateMatches.map(r => r.requisitionID));

// Check the variance data structure
if (surrenderDetails.length > 0) {
  console.log("=== ADVANCE ACTUALS AND VARIANCES STRUCTURE ===");
  const sampleDetail = surrenderDetails[0];
  console.log("Sample surrender detail:", sampleDetail);
  console.log("AdvanceActualsAndVariances:", sampleDetail.advanceActualsAndVariances);
  if (sampleDetail.advanceActualsAndVariances && sampleDetail.advanceActualsAndVariances.length > 0) {
    console.log("First variance item:", sampleDetail.advanceActualsAndVariances[0]);
    console.log("Variance calculation:", {
      advance: sampleDetail.advanceActualsAndVariances[0].advance,
      actualSpent: sampleDetail.advanceActualsAndVariances[0].actualSpent,
      variance: sampleDetail.advanceActualsAndVariances[0].variance
    });
  }
}

// Add this right after your existing debug code
console.log("=== SURENDER DETAILS FULL ANALYSIS ===");
surrenderDetails.forEach((detail, index) => {
  console.log(`Detail ${index + 1}:`, {
    requisitionID: detail.requisitionID,
    hasAdvanceActuals: !!detail.advanceActualsAndVariances,
    advanceActualsCount: detail.advanceActualsAndVariances?.length || 0,
    advanceActuals: detail.advanceActualsAndVariances,
    totalVariance: detail.totalVariance
  });
});


// Add this right after your existing debug code
console.log("=== SURENDER DETAILS FULL ANALYSIS ===");
surrenderDetails.forEach((detail, index) => {
  console.log(`Detail ${index + 1}:`, {
    requisitionID: detail.requisitionID,
    hasAdvanceActuals: !!detail.advanceActualsAndVariances,
    advanceActualsCount: detail.advanceActualsAndVariances?.length || 0,
    advanceActuals: detail.advanceActualsAndVariances,
    totalVariance: detail.totalVariance
  });
});
  
  return (
    <div id="wrapper">
      <Sidebar userType={theUserType} />

      {/* Content Wrapper */}
      <div id="content-wrapper" className="d-flex flex-column">
        {/* Main Content */}
        <div id="content">
          {/* Topbar */}
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            {/* Sidebar Toggle*/}
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
              <i className="fa fa-bars"></i>
            </button>

            {/* Topbar Search */}
            <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
              <div className="input-group">
                <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                  aria-label="Search" aria-describedby="basic-addon2" />
                <div className="input-group-append">
                  <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                  </button>
                </div>
              </div>
            </form>

            {/* Topbar Navbar */}
            <ul className="navbar-nav ml-auto">
              <TopBarIcons />
            </ul>
          </nav>
          {/* End of Topbar */}

          {/* Begin Page Content */}
          <div className="container-fluid">
            {/* Buttons Wrapper */}
              <div className="buttons-container">
                    
                  
            
                  <ExportTableToExcelButton
                    data={getExportData()}
                    fileName={`Staff_Surrenders_${activeTab.replace(' ', '_')}.xlsx`}
                  />
                  <ExportPDFButton contentRef={contentRef} />
              </div>

              <div id="printable-area" ref={contentRef}style={{ padding: '20px' }}>

            
            <h1 className="h3">Staff Surrenders Summary</h1>

            {/* Tabs */}
            <div className="tabs">
              <button
                className={`nav-link ${activeTab === 'Disbursed' ? 'active' : ''}`}
                onClick={() => handleTabClick('Disbursed')}
              >
                Disbursed Requisitions
              </button>
              <button
                className={`nav-link ${activeTab === 'Surrender Submitted' ? 'active' : ''}`}
                onClick={() => handleTabClick('Surrender Submitted')}
              >
                Surrenders Submitted (Review in Progress)
              </button>
            </div>

            
            {/* Error Message */}
            {error && (
              <div className="alert alert-warning mt-3" role="alert">
                {error}
              </div>
            )}

            {/* Error Message */}
            {error && (
              <div className="alert alert-warning mt-3" role="alert">
                {error}
              </div>
            )}

            {/* Total Amount Display - ONLY FOR DISBURSED TAB */}
            {activeTab === 'Disbursed' && (
              <div className="alert alert-success mt-3 d-flex justify-content-between align-items-center border-success">
                <div>
                  <i className="fas fa-money-bill-wave me-2"></i>
                  <strong className="text-success">Total Disbursed (not yet surrendered):</strong>
                  <span className="ms-2 fw-bold text-dark">
                    K {calculateTotalDisbursedAmount().toLocaleString()}
                  </span>
                </div>
                <div className="text-success">
                  <i className="fas fa-list-ol me-1"></i>
                  {requisitions.length} requisitions
                </div>
              </div>
            )}
           
           {/* Total Amount Display - FOR SURRENDER SUBMITTED TAB */}
          {activeTab === 'Surrender Submitted' && (
            <div className="alert alert-info mt-3 border-info">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <i className="fas fa-money-bill-wave me-2"></i>
                  <strong className="text-info">Total Disbursed (for surrenders that have been submitted):</strong>
                  <span className="ms-2 fw-bold text-dark">
                    K {surrenderRequisitions.reduce((total, req) => total + calculateTotalAmount(req.costDrivers), 0).toLocaleString()}
                  </span>
                </div>
                <div className="text-info">
                  <i className="fas fa-list-ol me-1"></i>
                  {surrenderRequisitions.length} requisitions
                </div>
              </div>
              <hr className="my-2" />
              <div className="d-flex justify-content-between align-items-center">
                <div>
                <i className="fas fa-money-bill-wave me-2"></i>
                  <strong className="text-info" >Total Variance:</strong>
                  <span className="ms-2 fw-bold text-dark" >
                    K {expectedSurrenderAmount.toLocaleString()}
                  </span>
                </div>
                <div className="text-info" >
                  <i className="fas fa-file-invoice me-1" ></i>
                  {surrenderDetails.length} surrenders
                </div>
              </div>
            </div>
          )}

            {/* Disbursed Requisitions Table  */}
            {activeTab === 'Disbursed' && (
              <div id="requisition-table" className="table-responsive mt-4">
                {loadingDisbursed ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mt-2">Loading...</p> {/* Loading disbursed requisitions... */}
                  </div>
                ) : (
                  <table className="table table-hover table-striped table-bordered text-sm align-middle">
                    <thead className="thead-dark">
                      <tr>
                        <th className="text-nowrap">Staff Name</th>
                        <th className="text-nowrap">Activity Name</th>
                        <th className="text-nowrap">Activity Duration</th>
                        <th className="text-nowrap">Amount Disbursed</th>
                        <th className="text-nowrap">Disbursed Date</th>
                        <th className="text-nowrap">Status</th>
                        <th className="text-nowrap">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requisitions
                        .slice()
                        .sort((a, b) => new Date(b.requisitionDate) - new Date(a.requisitionDate))
                        .map((requisition) => (
                          <tr key={requisition.requisitionID}>
                            <td>{requisition.staffName}</td>
                            <td>{requisition.activityName}</td>
                            <td>{formatDateRange(requisition.from, requisition.to)}</td>
                            <td>K {calculateTotalAmount(requisition.costDrivers).toLocaleString()}</td>
                            <td>{formatDate(requisition.disbursedDate)}</td>
                            <td>
                              <div className={`badge ${getStatusClass(requisition.status)}`}>
                                {requisition.status}
                              </div>
                            </td>
                            <td>
                              <div className="d-flex gap-2 flex-wrap">
                                <Link to={`/view-requisition/${requisition.requisitionID}`}>
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => handleView(requisition.requisitionID)}
                                  >
                                    <i className="fas fa-file-alt me-1"></i> View
                                  </button>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                      {requisitions.length === 0 && !error && (
                        <tr>
                          <td colSpan="7" className="text-center text-muted py-4">
                            No disbursed requisitions found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            )}


            {/* Surrender Submitted Table */}
            {activeTab === 'Surrender Submitted' && (
              <div id="requisition-table" className="table-responsive mt-4">
                {loadingSurrenderDetails ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span> {console.log("Loading variances...")}
                    </div>
                    <p className="mt-2">Loading...</p>{console.log("Loading surrender variances...")}
                  </div>
                ) : (
                  <table className="table table-hover table-striped table-bordered text-sm align-middle">
                  <thead className="thead-dark">
                    <tr>
                      <th className="text-nowrap">Staff Name</th>
                      <th className="text-nowrap">Activity Name</th>
                      <th className="text-nowrap">Activity Duration</th>
                      <th className="text-nowrap">Amount Disbursed</th> {/* This is the Disbursed Amount */}
                      <th className="text-nowrap">Disbursed Date</th>
                      <th className="text-nowrap">Variance</th>
                      <th className="text-nowrap">Status</th>
                      <th className="text-nowrap">Date Surrendered</th>
                      <th className="text-nowrap">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {surrenderRequisitions
                      .slice()
                      .sort((a, b) => new Date(b.requisitionDate) - new Date(a.requisitionDate))
                      .map((requisition) => {
                        // Debug: Log the matching process
                        console.log("Looking for surrender details for requisition:", requisition.requisitionID);
                        
                        const surrenderDetail = surrenderDetails.find(
                          detail => detail.requisitionID === requisition.requisitionID
                        );
                        
                        console.log("Found surrender detail:", surrenderDetail);
                        console.log("Available surrender details IDs:", surrenderDetails.map(d => d.requisitionID));
                        
                        // Calculate total variance manually as a fallback
                        const manualVariance = surrenderDetail?.advanceActualsAndVariances?.reduce((sum, variance) => {
                          return sum + (variance.variance || 0);
                        }, 0) || 0;
                        
                        const totalVariance = surrenderDetail?.totalVariance || manualVariance;
                        
                        console.log("Calculated variance:", {
                          fromTotalVariance: surrenderDetail?.totalVariance,
                          manualCalculation: manualVariance,
                          finalVariance: totalVariance,
                          advanceActuals: surrenderDetail?.advanceActualsAndVariances
                        });

                        return (
                          <tr key={requisition.requisitionID}>
                            <td>{requisition.staffName}</td>
                            <td>{requisition.activityName}</td>
                            <td>{formatDateRange(requisition.from, requisition.to)}</td>
                            <td>K {calculateTotalAmount(requisition.costDrivers).toLocaleString()}</td>
                            <td>{formatDate(requisition.disbursedDate)}</td>
                            <td className={totalVariance >= 0 ? 'text-success' : 'text-danger'}>
                              K {totalVariance.toLocaleString()}
                              {//surrenderDetail && (
                               // <small className="d-block text-muted">
                               //   {surrenderDetail.advanceActualsAndVariances?.length || 0} items
                               // </small>
                               //)
                              }
                            </td>
                            <td>
                              <div className={`badge ${getStatusClass(requisition.status)}`}>
                                {requisition.status}
                              </div>
                            </td>
                            <td>
                              {/* Date Surrendered - Get from surrender details */}
                              {surrenderDetail?.surrenderDateString ? formatDate(surrenderDetail.surrenderDateString) : 'N/A'}
                            </td>
                            <td>
                              <div className="d-flex gap-2 flex-wrap">
                                <Link to={`/view-requisition/${requisition.requisitionID}`}>
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => handleView(requisition.requisitionID)}
                                  >
                                    <i className="fas fa-file-alt me-1"></i> View
                                  </button>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    {surrenderRequisitions.length === 0 && !error && (
                      <tr>
                        <td colSpan="7" className="text-center text-muted py-4">
                          {/*No surrenders*/}
                        </td>
                      </tr>
                    )}
                  </tbody>
                  </table>
    )}
  </div>
)}
           

{
// <DebugVarianceData />
}
                  
            </div>
          {/* End of container-fluid */}
        </div>
        {/* End of Main Content */}
      </div>
        {/* Footer */}
        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Farm Concern Internationalal 2025</span>
            </div>
          </div>
        </footer>
        {/* End of Footer */}
      </div>
      {/* End of Content Wrapper */}
    </div>
  );
};

export default StaffSurrendersSummary;